export const LOGIN_NAME = 'login';

export const PASSWORD_NAME = 'password';

export const USER_NOT_FOUND_CODE = 'user-not-found';

export const PASSWORD_MISMATCH_CODE = 'password-mismatch';
